<template>
  <span class="reorder-controls">
    <button
      type="button"
      class="no-style reorder-btn"
      :disabled="!editable || index === 0"
      :aria-label="`Move ${plainLabel} up`"
      @click="move(-1)"
    >
      <span aria-hidden="true">&#9650;</span>
    </button>
    <button
      type="button"
      class="no-style reorder-btn"
      :disabled="!editable || index === list.length - 1"
      :aria-label="`Move ${plainLabel} down`"
      @click="move(1)"
    >
      <span aria-hidden="true">&#9660;</span>
    </button>
  </span>
</template>

<script>
/*
  Keyboard and touch alternative to drag-to-reorder.

  Addresses WCAG SC 2.1.1 Keyboard (audit 27.1) and SC 2.5.7 Dragging Movements (33.1):
  reordering must be possible without a dragging gesture.

  Like MatchSelect, this mutates the same array vuedraggable is bound to, so both input
  methods stay in sync and the activity's save logic is unchanged.
*/
export default {
  name: 'reorder-controls',
  props: {
    list: { type: Array, required: true },
    index: { type: Number, required: true },
    label: { type: String, default: '' },
    editable: { type: Boolean, default: true },
  },
  computed: {
    plainLabel() {
      return String(this.label).replace(/<[^>]*>/g, '') || `item ${this.index + 1}`;
    },
  },
  methods: {
    /* eslint-disable vue/no-mutating-props */
    move(delta) {
      const to = this.index + delta;
      if (to < 0 || to >= this.list.length) return;

      const [item] = this.list.splice(this.index, 1);
      this.list.splice(to, 0, item);

      // Keep focus on the button the user pressed, which has now moved with the item.
      this.$emit('moved', { from: this.index, to });
      this.$nextTick(() => {
        const btns = this.$parent.$el.querySelectorAll('.reorder-controls');
        const target = btns[to];
        if (target) {
          const b = target.querySelectorAll('button')[delta < 0 ? 0 : 1];
          if (b && !b.disabled) b.focus();
        }
      });
    },
    /* eslint-enable vue/no-mutating-props */
  },
};
</script>

<style scoped>
.reorder-controls {
  display: inline-flex;
  gap: 0.25rem;
  margin-right: 0.5rem;
}
.reorder-btn {
  padding: 0 0.35rem;
  cursor: pointer;
  line-height: 1.4;
}
.reorder-btn[disabled] {
  opacity: 0.4;
  cursor: not-allowed;
}
</style>
